import {
  Box,
  Card,
  CardContent,
  Stack,
  StackProps,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

interface StateCardProps extends Omit<StackProps, "title"> {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  fill?: boolean;
}

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(10, 4),

  "&:last-child": {
    paddingBottom: theme.spacing(10),
  },
}));

export const classes = {
  iconContainer: "StateCard-iconContainer",
};

export const StateCard = (props: StateCardProps) => {
  const {
    icon,
    title,
    description,
    actions,
    fill = false,
    sx,
    ...rest
  } = props;

  const contentEl = (
    <Stack
      spacing={4}
      {...rest}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        ...sx,
      }}
    >
      <Box
        className={classes.iconContainer}
        sx={{
          padding: 2.5,
          borderRadius: 4,
          backgroundColor: "secondary.6",
          boxShadow:
            "0px 0.5px 0px 0px rgba(226, 186, 248, 0.08) inset, 0px 0px 0.5px 0px rgba(226, 186, 248, 0.30) inset",
        }}
      >
        {icon}
      </Box>
      <Stack
        spacing={2.5}
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {title && (
          <Typography
            variant="regular"
            sx={{
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            variant="small"
            sx={{
              color: "secondary.3",
              textAlign: "center",
            }}
          >
            {description}
          </Typography>
        )}
      </Stack>
      {actions}
    </Stack>
  );

  if (fill) {
    return contentEl;
  }

  return (
    <Card>
      <StyledCardContent>{contentEl}</StyledCardContent>
    </Card>
  );
};
